import { Pagination } from '../utils/Pagination';

export default class SearchResult<T> {
  public data?: T[];
  public pagination?: Pagination;
  constructor(pData: T[], pPag: Pagination) {
    this.data = pData;
    this.pagination = pPag;
  }
}
